<!--
 * @description: 报修--保修申请
 * @param: 
 * @return: 
-->
<template>
    <div class="user-management-container">
        <tabel-panel ref="tabel" :rowTemplate="rowTemplate" api="getRepairList" :condition="conditionData2"
            editType="pop" :autoSearch="true" :showConditionSearch="false" :clickRowSelected="false"
            @customerRowDblClick="customerRowDblClick" :popToCustomer="true"
            @popConfirmButtonClick="popConfirmButtonClick">
            <template v-slot:tabelTitleLeft>
                <div>报修申请</div>
            </template>
            <template v-slot:tabelTitleRight>
                <update-button @buttonClick="addPower"> 添加 </update-button>
                <add-button @buttonClick="commitTools" class="commitCSS"> 提交 </add-button>
            </template>
            <template v-slot:condition>
                <el-form ref="ruleForm" label-width="80px" class="demo-ruleForm">
                    <el-form-item label="客户:" prop="" required>
                        <el-select v-model="companyID" clearable filterable placeholder="请选择" @change="companyValue"
                            size="small">
                            <el-option v-for="item in companyData" :key="item.Company_Id" :label="item.CompName"
                                :value="item.Company_Id">
                            </el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item label="公司联系人:" label-width="100px" prop="" required>
                        <el-select v-model="LinkManID" clearable placeholder="请输入公司联系人" @change="resetValue"
                            size="small">
                            <el-option v-for="item in LinkManData" :key="item.id" :label="item.LinkMan"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item label="联系人:" prop="" required>
                        <el-input v-model="formInline.LinkMan" placeholder="请输入联系人" size="small"></el-input>
                    </el-form-item>

                    <el-form-item label="联系电话:" prop="">
                        <el-input v-model="formInline.TelNo" placeholder="请输入电话" size="small"></el-input>
                    </el-form-item>
                    <el-form-item label=" 联系手机:" prop="" label-width="100px" required>
                        <el-input v-model="formInline.Phone" placeholder="请输入手机" size="small"></el-input>
                    </el-form-item>
                    <el-form-item label="Email:" prop="" required>
                        <el-input v-model="formInline.Email" placeholder="请输入Email" size="small"></el-input>
                    </el-form-item>
                    <el-form-item label=" 传真:" prop="">
                        <el-input v-model="formInline.Fax" placeholder="请输入传真" size="small"></el-input>
                    </el-form-item>
                    <el-form-item label="邮编:" prop="">
                        <el-input v-model="formInline.Post" placeholder="请输入邮编" size="small"></el-input>
                    </el-form-item>

                    <el-form-item label="中心地址">
                        <el-input v-model="formInline.Address" placeholder="地址" size="small"></el-input>
                    </el-form-item>
                </el-form>
            </template>
            <template v-slot:oprator="$opData">
                <div class="opration">
                    <del-button class="item" :useConfirm="true" comfirmMessage="确定删除吗？" comfirmOkText="确定"
                        comfirmCancelText="取消" @buttonClick="delSingleUser($opData.data)"></del-button>
                </div>
            </template>
        </tabel-panel>
        <pop-dialog id="loadBOX" @confirmClick="listDataSave" v-if="loadShow" ref="getMenuList" :meta="popDialogList"
            detailShowType="data" @dialogClose="loadShow = false">
            <template v-slot="idData">
                <div class="saveBox">
                    <div style="color:red; padding:0; margin:0; text-align: center;">
                        <div style="font-size:0.15rem;"> 温馨提示</div>
                        如无电源故障，请不要寄送电池、电池盖、外壳保护套及SD卡、sim卡等配件，以免丢失  
                    </div>
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <div class="grid-content bg-purple">
                                <span class="colorRed">*</span>
                                品牌名称:
                                <el-select v-model="popSaveData.BrandId" clearable placeholder="请选择"
                                    @change="addProductSelect" required size="small">
                                    <el-option v-for="item in BrandData" :key="item.id" :label="item.Name"
                                        :value="item.id">
                                    </el-option>
                                </el-select>
                            </div>
                        </el-col>
                        <el-col :span="12">
                            <div class="grid-content bg-purple">
                                <span class="colorRed">*</span>
                                产品类别:
                                <el-select v-model="popSaveData.ProductId" clearable size="small" placeholder="请选择"
                                    @change="addModelSelect">
                                    <el-option v-for="item in ProductData" :key="item.id" :label="item.Name"
                                        :value="item.id">
                                    </el-option>
                                </el-select>
                            </div>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <div class="grid-content bg-purple">
                                <span class="colorRed">*</span>
                                产品型号:
                                <el-select v-model="popSaveData.ModelNoid" clearable size="small" placeholder="请选择">
                                    <el-option v-for="item in modelData" :key="item.id" :label="item.Name"
                                        :value="item.id">
                                    </el-option>
                                </el-select>
                            </div>
                        </el-col>
                        <el-col :span="12">
                            <div class="grid-content bg-purple">
                                    <span class="colorRed">*</span>
                                    产品症状:
                                <el-select aria-label="ffff" size="small" v-model="popSaveData.ModelIllId" clearable placeholder="请选择"
                                    @change="addModelIllID">
                                    <el-option v-for="item in ModelIllData" :key="item.id" :label="item.Name" :value="item.id">
                                    </el-option>
                                </el-select>
                                <!-- <span class="colorRed">*</span>
                                SN号:<el-input size="small" v-model="popSaveData.SerialNoName" placeholder="请输入SN号" required
                                    @change="SNSearch" class="inputSN"></el-input> -->
                            </div>
                        </el-col>
                    </el-row>
                    <div>
                        <span>附件:</span>
                        <el-checkbox-group v-model="checkedList">
                            <el-checkbox v-for="city in AttachData" :label="city.id" :key="city.id"
                                @change="handleCheckedCitiesChange(city)" :value="city.Name">
                                {{ city.Name }}
                            </el-checkbox>
                        </el-checkbox-group>
                    </div>
                    <div style="display: flex; justify-content: space-between;">
                        <!-- 批量添加sn -->
                        <div style="width: 45%;">
                            <span class="colorRed">*</span>
                            SN号:
                            <el-input size="small" type="textarea" 
                            :autosize="{ minRows: 2, maxRows: 4 }" 
                            placeholder="可以批量增加SN号"
                            v-model="popSaveData.SerialNoName" 
                            @change="clearModelIllID"></el-input>
                        </div>

                        <div style="width: 45%;">
                            <span>症状信息:</span>
                            <el-input size="small" type="textarea" :autosize="{ minRows: 2, maxRows: 4 }" placeholder=""
                                v-model="popSaveData.CusApp" @change="clearModelIllID"></el-input>
                        </div>
                    </div>
                    <div>
                        <span>备注:</span>
                        <el-input size="small" type="textarea" :autosize="{ minRows: 2, maxRows: 4 }"
                            placeholder="请输入内容" v-model="popSaveData.IllDesc"></el-input>
                    </div>
                </div>
            </template>
        </pop-dialog>
    </div>
</template>

<script>
import delButton from "@/components/delButton.vue";
import addButton from "@/components/addButton.vue";
import updateButton from "@/components/updateButton.vue";
import tabelPanel from "@/components/tabelPanel.vue";
import popDialog from "@/components/popDialog.vue";
import tableApi from "@/api/tabel.js";
import {
    CompanyInfoes,
    linkMan,
    RepairDelete,
    RepairAdd,
    CusRepairApplyEdits,
} from "@/api/index.js";
import { errMsg, successMsg } from "@/notify/index.js";

export default {
    name: "CusRepairList",
    components: {
        addButton,
        delButton,
        tabelPanel,
        popDialog,
        updateButton,
    },
    data() {
        const selectValueFn1 = (v, item) => {
            if (item) {
                return item.CompName;
            }
        };
        const selectRemoteSearchData1 = async () => {
            let source = await tableApi.CompanyInfoId();
            if (source.code == 0) {
                let data = source.data.list.map(({ Company_Id, CompName }) => {
                    return {
                        label: CompName,
                        value: Company_Id,
                    };
                });
                let total = 0;
                return {
                    total,
                    data,
                };
            } else {
                errMsg(source.message);
            }
        };
        const cityOptions = [
            { id: 11, Name: "屏幕", checked: false },
            { id: 12, Name: "DDW", checked: true },
        ];
        return {
            checkAll: false,
            checkedCities: [{ id: 11, Name: "屏幕", checked: true }],
            cities: cityOptions,
            isIndeterminate: true,
            loadShow: false,
            // 品牌数据
            BrandData: null,
            //产品类别
            ProductData: null,
            //产品型号
            modelData: null,
            //附件
            AttachData: null,
            //症状:
            ModelIllData: null,
            popSaveData: {
                BrandId: null,      // BrandId	int	品牌Id  1 AttachInfoId
                ProductId: null,    // ProductId	int	产品Id 1
                CusApp: "",         // CusApp	string	症状信息
                ModelNoid: null,    // ModelNoid	int	型号Id 1
                ModelIllId: null,   // ModelIllId	int	症状id 1
                SerialNoName: "",   // SerialNoName	string	SN 1
                AttachInfoId: null, // AttachInfoId	Int	附件Id
                IllDesc: "",        // IllDesc	string	备注 1
                AttachName: "",     //string  附件名称
            },
            // 维修中心
            listData: [{}],
            rowTemplate: [
                {
                    headerLabel: "品牌",
                    sortable: true,
                    dataIndex: "BrandName",
                },
                {
                    headerLabel: "产品",
                    sortable: true,
                    dataIndex: "ProductName",
                },
                {
                    headerLabel: "型号",
                    sortable: true,
                    dataIndex: "ModelNoStr",
                },
                {
                    headerLabel: "SN号",
                    sortable: true,
                    dataIndex: "SerialNoName",
                },
                {
                    headerLabel: "备注",
                    dataIndex: "IllDesc",
                },
                {
                    headerLabel: "附件",
                    dataIndex: "AttachName",
                },
                {
                    headerLabel: "症状信息",
                    dataIndex: "CusApp",
                    // width:360,
                },
                {
                    headerLabel: "删除",
                    slot: "oprator",
                    width: null,
                },
                {
                    headerLabel: "品牌名称",
                    dataIndex: "companyId",
                    requird: true,
                    editable: true,
                    editType: "select",
                    selectRemoteSearchData: selectRemoteSearchData1,
                    selectValueFn: selectValueFn1,
                    rules: [
                        {
                            required: true,
                            message: "请选择品牌名",
                        },
                    ],
                    showInList: false,
                },
                {
                    headerLabel: "产品类型",
                    dataIndex: "companyId",
                    requird: true,
                    editable: true,
                    editType: "select",
                    selectRemoteSearchData: selectRemoteSearchData1,
                    selectValueFn: selectValueFn1,
                    rules: [
                        {
                            required: true,
                            message: "请选择品牌名",
                        },
                    ],
                    showInList: false,
                },
                {
                    headerLabel: "产品型号",
                    dataIndex: "companyId",
                    requird: true,
                    editable: true,
                    editType: "select",
                    selectRemoteSearchData: selectRemoteSearchData1,
                    selectValueFn: selectValueFn1,
                    rules: [
                        {
                            required: true,
                            message: "请选择品牌名",
                        },
                    ],
                    showInList: false,
                },
                {
                    headerLabel: "SN号",
                    dataIndex: "companyId",
                    requird: true,
                    editable: true,
                    rules: [
                        {
                            required: true,
                            message: "请选择品牌名",
                        },
                    ],
                    showInList: false,
                },
                {
                    headerLabel: "符件",
                    dataIndex: "AttachId",
                    requird: true,
                    editable: true,
                    editType: "checkbox",
                    rules: [
                        {
                            required: true,
                            message: "请选择品牌名",
                        },
                    ],
                    showInList: false,
                },
                {
                    headerLabel: "症状描述",
                    dataIndex: "companyId",
                    requird: true,
                    editable: true,
                    editType: "select",
                    selectRemoteSearchData: selectRemoteSearchData1,
                    selectValueFn: selectValueFn1,
                    rules: [
                        {
                            required: true,
                            message: "请选择品牌名",
                        },
                    ],
                    showInList: false,
                },
                {
                    headerLabel: "SN系统标注信息",
                    dataIndex: "companyId",
                    requird: true,
                    editable: true,
                    rules: [
                        {
                            required: true,
                            message: "请选择品牌名",
                        },
                    ],
                    showInList: false,
                },
                {
                    headerLabel: "备注",
                    dataIndex: "companyId",
                    requird: true,
                    editable: true,
                    rules: [
                        {
                            required: true,
                            message: "请选择品牌名",
                        },
                    ],
                    showInList: false,
                },
            ],
            companyData: [],
            companyID: null,
            LinkManData: null,
            LinkManID: null,
            formInline: {
                Address: null, // Address	string	地址	是
                CompanyName: null,
                compId: 3, // compId	int	公司id	是
                Email: null, // Email	string	邮件
                Fax: null, //	Fax	string	传真
                LinkMan: null, // LinkMan	string	联系人	是
                Phone: null, // Phone	string	手机	是
                Post: null, // Post	string	邮编
                TelNo: null, //TelNo	string	联系电话	是
            },
            conditionData: {},
            conditionData2: null,
            conditionDatas: {},
            CusAppArr: [],
            checkedListS: [],
            checkedList: [],
            checkedListId: [],
            checkedListArr: [],
        };
    },
    created() {
        this.companyAdd();
    },
    watch: {
        // 'popSaveData.BrandId': {
        //     deep: true,
        //     handler: function () {
        //         this.addProductSelect()
        //         this.addModelSelect()
        //     }
        // }
    },
    methods: {
        handleCheckedCitiesChange(value) {
            console.log("value--", value);
            this.checkedListArr.push(value.Name);
            this.checkedListId.push(value.id);
            this.popSaveData.AttachInfoId = this.checkedListId.toString();
            this.popSaveData.AttachName = this.checkedListArr.toString();
            console.log("this.checkedList---", this.checkedList);
        },
        reloadData() {
            this.$refs.tabel.reloadData();
        },
        //列表提交
        commitTools() {
            // let sels = this.$refs.tabel.getSelection()
            let sels = this.$refs.tabel.dataSource;
            if (sels.length == 0) {
                errMsg("至少选择一行数据")
                return
            }
            if (!this.formInline.Phone) {
                errMsg("联系手机不能为空")
                return
            }
            let ocmmitData = this.formInline;
            if (!ocmmitData.Address) {
                ocmmitData.Address = "";
            }
            if (!ocmmitData.Email) {
                ocmmitData.Email = "";
            }
            if (!ocmmitData.Fax) {
                ocmmitData.Fax = "";
            }
            if (!ocmmitData.Phone) {
                ocmmitData.Phone = "";
            }
            if (!ocmmitData.Post) {
                ocmmitData.Post = "";
            }
            if (!ocmmitData.TelNo) {
                ocmmitData.TelNo = "";
            }
            if (ocmmitData.Company_Id) {
                ocmmitData.compId = ocmmitData.Company_Id;
                delete ocmmitData.Company_Id;
                delete ocmmitData.id;
            }

            // let id = sels.map((m) => m.id);

            if (
                this.formInline.LinkMan === undefined ||
                this.formInline.LinkMan === null
            ) {
                errMsg("请选择客户和联系人");
            } else {
                ocmmitData.list = sels;
                sels.forEach((i) => {
                    i.AttachId;
                    console.log("AttachId:", i.AttachId);
                });
                console.log('1223', ocmmitData)
                CusRepairApplyEdits(ocmmitData).then((data) => {
                    if (data.code == 0) {
                        successMsg(data.message);
                        // 清楚
                        this.companyID = null
                        this.companyValue()
                        this.reloadData();
                    } else {
                        errMsg(data.message);
                    }
                });
            }
        },
        //列表删除
        delSingleUser({ row }) {
            let id = row.id;
            RepairDelete({ id }).then((data) => {
                if (data.code == 0) {
                    successMsg(data.message);
                    this.reloadData();
                } else {
                    errMsg(data.message);
                }
            });
        },
        // 保存列表
        listDataSave({ slotData }) {
            
            let RepairSaveData = this.popSaveData;
            if (RepairSaveData.ModelNoid == "" || RepairSaveData.ModelNoid == null) {
                errMsg("型号不能为空");
                return;
            }
            if (RepairSaveData.SerialNoName == "" || RepairSaveData.SerialNoName == null) {
                errMsg("SN号不能为空");
                return;
            }
            if (RepairSaveData.ModelIllId == "" || RepairSaveData.ModelIllId == null) {
                errMsg("症状不能为空");
                return;
            }
            let stingArr = this.checkedList.toString();
            RepairSaveData.AttachInfoId = stingArr

            switch (RepairSaveData.AttachInfoId) {
                case 'NaN':
                    RepairSaveData.AttachInfoId = ''
                    break;
                case 0:
                    RepairSaveData.AttachInfoId = ''
                    break
                default:
                    break;
            }

            RepairSaveData.id = slotData.id;
            if (slotData.id === 0) {
                RepairAdd(RepairSaveData).then((data) => {
                    if (data.code == 0) {
                        successMsg(data.message);
                        this.reloadData();
                        this.clearableFrom();
                        this.loadShow = false;
                    } else {
                        errMsg(data.message);
                    }
                });
            } else {
                RepairAdd(RepairSaveData).then((data) => {
                    if (data.code == 0) {
                        successMsg(data.message);
                        this.reloadData();
                        this.clearableFrom();
                        this.loadShow = false;
                    } else {
                        errMsg(data.message);
                    }
                });
            }
        },
        clearModelIllID() {
            this.CusAppArr = []
            this.addListForm.CusApp = ''
        },
        clearableFrom() {
            this.checkedList = [];
            this.popSaveData.SerialNoName = "";
            this.popSaveData.AttachInfoId = "";
            this.popSaveData.AttachName = "";
        },
        addPower() {
            this.popSaveData.BrandId = null
            this.popSaveData.ProductId = null
            this.popSaveData.ModelNoid = null
            this.popSaveData.ModelIllId = null
            this.popSaveData.SerialNoName = null
            this.AttachData = null
            let id = 0;
            this.loadShow = true;
            this.$nextTick(() => {
                this.$refs.getMenuList.showPopDialog(
                    { id },
                    "维修设备信息添加",
                    "slot"
                );
            });
            this.celarPop()
        },
        companyAdd() {
            CompanyInfoes().then((data) => {
                if (data.code == 0) {
                    this.companyData = data.data.list;
                    this.companyData.forEach((i) => {
                        if (i.pid) {
                            console.log('@', i)
                            this.companyID = i.Company_Id
                            this.companyValue()
                        }
                    })

                    // pid: 1
                } else {
                    errMsg(data.message);
                }
            });

            tableApi.BrandSelect().then((data) => {
                if (data.code == 0) {
                    this.BrandData = data.data.list;
                } else {
                    errMsg(data.message);
                }
            });
        },
        //产品类别
        addProductSelect() {
            let Bid = this.popSaveData.BrandId;
            tableApi.ProductSelect({ Bid }).then((data) => {
                if (data.code == 0) {
                    this.ProductData = data.data.list;
                } else {
                    errMsg(data.message);
                }
            });
        },
        //产品型号
        addModelSelect() {
            let ProductCategoryId = this.popSaveData.ProductId;
            tableApi.modelSelect({ ProductCategoryId }).then((data) => {
                if (data.code == 0) {
                    this.modelData = data.data.list;
                } else {
                    errMsg(data.message);
                }
            });
            this.addAttachSelect();
            this.addModelIllSelect();
        },
        //附件
        addAttachSelect() {
            let ProductCategoryId = this.popSaveData.ProductId;
            tableApi.AttachSelect(ProductCategoryId).then((data) => {
                if (data.code == 0) {
                    this.AttachData = data.data.list;
                } else {
                    errMsg(data.message);
                }
            });
        },
        //症状:
        addModelIllSelect() {
            let ProductCategoryId = this.popSaveData.ProductId;
            tableApi.ModelIllSelect({ ProductCategoryId }).then((data) => {
                if (data.code == 0) {
                    this.ModelIllData = data.data.list;
                } else {
                    errMsg(data.message);
                }
            });
        },
        //
        addModelIllID(val) {
            let obj = {};
            obj = this.ModelIllData.find(function (item) {
                return item.id === val;
            });
            this.CusAppArr.push(obj.Name);
            this.popSaveData.CusApp = this.CusAppArr.toString();
        },
        companyValue() {
            this.LinkManID = null;
            this.LinkManData = null;
            this.formInline = {};

            let Company_Id = this.companyID;
            if (Company_Id === null) {
                console.log("选择公司")
            } else {
                linkMan({ Company_Id }).then((data) => {
                    if (data.code == 0) {
                        this.LinkManData = data.data.list;
                    } else {
                        errMsg(data.message);
                    }
                });
            }
        },
        resetValue(v) {
            console.log('@', v)
            let zxc = this.LinkManData.filter((i) => {
                if (i.id == v) {
                    return i
                }
            })
            console.log('@2', zxc)
            this.formInline = zxc[0];
            // id: 2055, LinkMan: "李智恩"
        },
        //弹层事件
        popConfirmButtonClick({ slotData }) {
            alert(123);
        },
        // 修改
        customerRowDblClick(row) {
            console.log("row:", row);
            this.loadShow = true;
            this.rowData = row;
            //品牌
            this.popSaveData.BrandId = row.BrandId;
            // this.BrandData = [{id: 1, Name: "TCL"}]
            this.addProductSelect();
            // 产品 id: 2, Name: "大屏s"
            this.popSaveData.ProductId = row.ProductId;
            // this.ProductData = [{id: 2, Name: "大屏s"}]
            // 型号
            this.popSaveData.ModelNoid = row.ModelNo_Id;
            // this.modelData = [{id: 1034, Name: "F1"}]
            // 附件
            this.addModelSelect();
            // this.checkedTrue(row)
            // 症状
            this.popSaveData.ModelIllId = row.ModelIllsId;
            // this.ModelIllData = [{id: 1, Name: "TCL"}]
            // 系统标注信息:
            this.popSaveData.CusApp = row.CusApp;
            // 备注:
            this.popSaveData.IllDesc = row.IllDesc;
            // SN号:
            this.popSaveData.SerialNoName = row.SerialNoName;
            this.$nextTick(() => {
                this.$refs.getMenuList.showPopDialog(
                    row,
                    "维修设备编辑信息",
                    "slot"
                );
            }),
            this.checkedTrue();
        },
        checkedTrue() {
            if ( this.rowData.AttachId == '') {
                return
            }

            let AttachIds = this.rowData.AttachId.split(",").map((a) =>
                parseInt(a)
            );
            this.checkedList = AttachIds;
        },
        SNSearch(v) {
            console.log(v)
            tableApi.SearchCusApplyRepairBySN({ sns: v }).then((data) => {
                if (data.code == 0) {
                    let sn = data.data.list;
                    console.log('sn@', sn)
                    this.popSaveData.BrandId = sn.BrandId
                    this.popSaveData.ProductId = sn.ProCateId
                    this.popSaveData.ModelNoid = sn.ModelNoId
                    this.popSaveData.ModelIllId = null
                    this.popSaveData.CusApp = ""
                    this.popSaveData.IllDesc = ""
                    this.CusAppArr = []
                    this.checkedList = []
                    this.addProductSelect()
                    this.addModelSelect()
                } else {
                    errMsg(data.message)
                    // this.popSaveData.BrandId = null
                    // this.popSaveData.ProductId = null
                    // this.popSaveData.ModelNoid = null
                    // this.AttachData = null
                    // this.addModelSelect()
                }
            })
        },
        celarPop() {
            this.clearModelIllID()
            this.popSaveData.BrandId = null
            this.popSaveData.ProductId = null
            this.popSaveData.ModelNoid = null
            this.popSaveData.ModelIllId = null
            this.ModelIllData = null
            this.ProductData = null
            this.modelData = null
            this.AttachData = null
            this.popSaveData.CusApp = ""
            this.CusAppArr = []
            this.checkedList = []
            this.popSaveData.IllDesc = ""
        }
    },
};
</script>

<style lang="scss" scoped="scoped">
@import "~@/assets/styles/_handle.scss";

// .labelSpan{
// 	float: left;
// }
#suerSwitch .el-switch__core {
    width: 26px;
}

.user-management-container {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    overflow: hidden;
    align-items: center;
    align-content: center;
    @include background_color("user-management-bg-color");

    .table-panel-containers .condition-containe {
        height: 200px;
    }

    .demo-ruleForm {
        display: flex;
        flex-wrap: wrap;

        .el-form-item,
        .is-required {
            width: 300px;
            margin-bottom: 10px;
            color: #165ff1;

            .itemInput {
                color: red;
            }
        }
    }


    .del {
        margin-left: 10px;
    }

    .condition-container-input {
        width: 270px;
    }

    .opration {
        height: 100%;
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        align-content: center;

        .item {
            &:nth-child(n + 1) {
                margin-left: 10px;
            }
        }
    }

    .menuPowerBOX {
        .el-button--default {
            width: 90px;
            height: 30px;
            color: #ffffff;
            background: rgb(100, 134, 232);
            border-radius: 4px;
        }

        .item {
            height: 30px;
            color: #ffffff !important;
            padding: 10px 15px !important;
            background: rgb(100, 134, 232) !important;
        }
    }

    .oprationTree {
        height: 300px;
        overflow: auto;
    }

    #loadBOX {
        width: 100%;

        .saveBox {
            width: 800px !important;
        }

        .saveBox>div {
            padding: 10px;
            margin: 10px;

            .el-checkbox {
                margin-right: 15px;
            }

            .colorRed {
                color: red;
            }
        }
    }

}

.el-select-dropdown__item {
    text-align: left;
    padding: 0 10px;
}

.el-input {
    width: 100%;
}

.commitCSS {
    margin-left: 15px;
}

.inputSN {
    width: 75%;
}

::v-deep .el-form-item__label {
    color: black;
    font-weight: bold;
    font-size: 18px;
}
</style>
